import { UserPrefs } from '../../types/UserPrefs.types.js';

import { closeDialog } from '../../util/dialog_helpers.js';
import { updatePrefs } from '../../util/user_prefs_util.js';


export function attachEventHandlers(dialog: HTMLElement) {
  const okButton = dialog.querySelector('[data-id="typekit-onboarding-modal-ok-button"]');
  if (okButton) {
    okButton.addEventListener('click', handleOkButtonClick, { once: true });
  }
}

async function handleOkButtonClick() {
  updatePrefs({ hideTypekitOnboardModal: true } as UserPrefs);

  closeDialog();
};
